import { Style, Icon, Stroke, Fill, Text } from 'ol/style';
import Point from 'ol/geom/Point';
import LineString from 'ol/geom/LineString';
import Polygon from 'ol/geom/Polygon';
import MultiPolygon from 'ol/geom/MultiPolygon';

export const REASON = {
  SX: '三夏',
  SQ: '三秋',
};

// 收割热力:thermodynamic, 收割进度:progression
// 收获类机械 // machineryType 农机品类 0全部 1收获类机械 2播种类机械 3插秧类机械 4耕整类机械 5植保类机械 6收获后处理机械 7其他机械
export const DV_VEHICLE_MODEL_CODES = ['1'];

export const CHART_CONFIG_SECTION = {
  /**
   * 自定义 tooltip 样式
   *   tooltip: {
   *     formatter: CHART_CONFIG_SECTION.tooltipFormatter({ unit: ['台', '户'], border: 'none', borderRadius: 0 }),
   *     formatter: CHART_CONFIG_SECTION.tooltipFormatter({ unit: '万元' }),
   *     formatter: CHART_CONFIG_SECTION.tooltipFormatter({ unit: '万元', name: '中央补贴资金' }),
   *   },
   * border: 文字左侧的色块是否添加白色边框，默认为 '2px solid #FFF'
   * borderRadius: 文字左侧的色块的圆角，默认为 '50%'
   * name: 使用指定的名称覆盖各自的 series.name，用于 series 只有一项时
   */
  tooltipFormatter: (config) => (params) => {
    // console.log('tooltipFormatter', { config, params });
    const { unit = '', border = '2px solid #FFF', borderRadius = '50%', name: forceName, direction = 'bottom', height = '1em' } = config || {};
    const type = Array.isArray(params) ? 'array' : typeof params;
    let htmlHead = '';
    let htmlBody = '';
    const getColorFromEchartsLinearGradient = (color) => {
      if (color && typeof color == 'object' && color.type == 'linear') {
        const colorStops = color.colorStops;
        if (colorStops.length) {
          // console.log('colorStops[colorStops.length - 1]', colorStops, colorStops[colorStops.length - 1]);
          const from = colorStops[0].color;
          const to = colorStops[colorStops.length - 1].color;
          return `linear-gradient(to ${direction || 'bottom'}, ${from}, ${to})`;
        }
      }
      return color;
    };
    const getItemHtml = (obj = {}, index) => {
      const currentUnit = unit && Array.isArray(unit) ? unit[index == null ? 0 : index] : unit;
      const config = {
        unit: currentUnit,
        border,
        borderRadius,
        ...obj,
        color: obj.color && getColorFromEchartsLinearGradient(obj.color),
        seriesName: obj.seriesName ? `${obj.seriesName}：` : '',
        value: obj.value ? obj.value.toLocaleString('zh') : obj.value, // 千分位
        height: obj.height || '1em', // marker 高度
      };
      const reg = new RegExp(`{(${Object.keys(config).join('|')})}`, 'g');
      let itemTpl = `
        <div style="padding-top:0.5em;">
          <span style="display:inline-block;width:1em;height:{height};background:{color};border-radius:{borderRadius};border:{border};vertical-align:middle;"></span>
          <span style="display:inline-block;vertical-align:middle;padding-left:0.2em;">{seriesName} {value} {unit}</span>
        </div>
      `;
      return itemTpl.replace(reg, (match) => config[match.replace(/[{}]/g, '')]);
    };
    // array: 拆线图/柱图
    if (type == 'array') {
      htmlHead = `<div>${forceName ? forceName : params[0] && params[0].name}</div>`;
      params.forEach((item, index) => {
        const { color = '#5473E8', value } = item || {};
        let { seriesName } = item || {};
        if (params.length <= 1) {
          seriesName = null;
        }
        // console.log('color', typeof color, color);
        htmlBody += getItemHtml({ seriesName, color, value, height }, index);
      });
    }
    // object 饼图
    else if (type == 'object') {
      htmlHead = `<div>${forceName ? forceName : params && params.name}</div>`;
      const { color = '#5473E8', value } = params || {};
      const seriesName = null; // seriesName: "series\u00000"
      htmlBody += getItemHtml({ seriesName, color, value, height });
    }
    const html = `<div style="color:#FFF;line-height:1;font-size:14px;padding:0.5em;">${htmlHead}${htmlBody}</div>`;
    // console.log('tooltipFormatter', { config, params, type, html });
    return html;
  },
};

// 边界样式
export const MapStyles = {
  boundaryDefault: new Style({
    fill: new Fill({
      color: 'rgba(255,255,255,0)',
    }),
    stroke: new Stroke({
      color: 'rgba(255,255,255,0)',
      width: 2,
    }),
  }),
  // 行政区块的选中状态和默认状态
  region: {
    default: new Style({
      fill: new Fill({
        color: 'rgba(255,255,255,0)',
      }),
      // stroke: new Stroke({
      //   color: 'rgba(255,255,255,0)',
      //   width: 2,
      // }),
    }),
    active: new Style({
      fill: new Fill({
        color: 'rgba(86,175,255,1)',
      }),
      // stroke: new Stroke({
      //   color: 'rgba(255,255,255,1)',
      //   width: 2,
      //   lineDash: [10, 10],
      // }),
    }),
  },
};
export const GET_TOWN_AREACODE = (len12code, len = 9) => {
  return (len12code && '' + len12code).slice(0, len);
};
export const GET_FEATURE_AREACODE = (feature) => {
  const properties = feature.getProperties();
  const areaId = feature.get('adcode') || GET_TOWN_AREACODE(properties.乡级代码, 9);
  return areaId;
};
// 取质心点
export const GET_FEATURE_CENTROID = function (feature) {
  const geometry = feature.getGeometry();
  if (geometry instanceof Point) {
    return geometry.getCoordinates();
  } else if (geometry instanceof LineString) {
    return geometry.getCoordinateAt(0.5);
  } else if (geometry instanceof Polygon) {
    // return geometry.getCentroid();
    return geometry.getInteriorPoint().getCoordinates();
  } else if (geometry instanceof MultiPolygon) {
    const polygons = geometry.getPolygons();
    // const centroids = polygons.map((polygon) => polygon.getCentroid());
    const centroids = polygons.map((polygon) => polygon.getInteriorPoint().getCoordinates());
    const xSum = centroids.reduce((sum, centroid) => sum + centroid[0], 0);
    const ySum = centroids.reduce((sum, centroid) => sum + centroid[1], 0);
    const xAverage = xSum / centroids.length;
    const yAverage = ySum / centroids.length;
    return [xAverage, yAverage];
  } else {
    console.warn('获取不到中心点：不支持的几何类型', feature);
  }
};

// 获取预警图标 收割热力:thermodynamic,收割进度:progression,天气weather
export const GetWarningIcon = function (type = 'weather', levelCode = '', categoryCode = '0000') {
  let src = null;
  let category = ('' + categoryCode).padStart(4, '0');
  let level = ('' + levelCode).padStart(3, '0');
  if (/^p\d{4}\d{3}$/.test(levelCode)) {
    category = levelCode.slice(1, 5);
    level = levelCode.slice(5, 8);
  }
  if (['weather', 'thermodynamic', 'progression'].includes(type)) {
    src = `/images/warning/${type}/p${category}${level}.png`;
    if (!levelCode) {
      src = `/images/warning/${type}/default.png`;
    }
  } else {
    console.warn('不支持的预警类型', type);
  }
  return src;
};

export const THERMODYNAMIC_COLOR = ['#57FF57', '#FFE121', '#FF5121'];
// 取渐变色指定位置的色值，取值范围 0~1
export const GetColorFromLinner = function (pos = 0.5, alpha = 0.55, colors = null) {
  const linnerColors = colors || THERMODYNAMIC_COLOR;
  // 将十六进制颜色转换为 RGB 格式
  const hexToRgb = function (hex) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return { r, g, b };
  };
  // 将 RGB 格式转换为十六进制颜色
  const rgbToHex = function (r, g, b) {
    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
  };
  // 计算两个颜色之间的插值颜色
  const interpolateColor = function (color1, color2, factor) {
    const rgb1 = hexToRgb(color1);
    const rgb2 = hexToRgb(color2);
    const r = Math.round(rgb1.r + factor * (rgb2.r - rgb1.r));
    const g = Math.round(rgb1.g + factor * (rgb2.g - rgb1.g));
    const b = Math.round(rgb1.b + factor * (rgb2.b - rgb1.b));
    return rgbToHex(r, g, b);
  };
  // 计算渐变色中的颜色值
  const getGradientColor = function (colors, position) {
    // 确保位置在 0 到 1 之间
    position = Math.min(1, Math.max(0, position));
    const numColors = colors.length;
    const index = Math.floor(position * (numColors - 1));
    const weight = (position * (numColors - 1)) % 1;
    const color1 = colors[index];
    const color2 = colors[index + 1] || color1; // 如果是最后一个颜色，直接返回
    return interpolateColor(color1, color2, weight);
  };
  // console.log({linnerColors});
  // 将0~1的alpha值转换为两位十六进制
  const alphaHex = Math.round(alpha * 255)
    .toString(16)
    .padStart(2, '0');
  const color = getGradientColor(linnerColors, pos);
  // console.log('%c渐变色指定位置的色值', 'color:#CC0', { pos, alpha, color, alphaHex });
  return color + alphaHex; // 返回带透明度的颜色值
};
